import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;

const NavLink = ({ to, children, ...rest }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.shiftKey) {
      return;
    }
    e.preventDefault();
    navigate(to);
  };

  return (
    <StyledLink href={to} onClick={handleClick} {...rest}>
      {children}
    </StyledLink>
  );
};

export default NavLink;
